// src/pages/users/UserForm.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Grid,
  Typography,
  FormHelperText,
  Card,
  CardContent,
  Checkbox,
  Radio,
  FormControlLabel,
  RadioGroup,
} from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import userService from '../../services/userService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import {
  filter,
  find,
  flatMap,
  includes,
  isEmpty,
  isEqual,
  join,
  last,
  map,
  omit,
  range,
  split,
  toUpper,
  uniqBy,
} from 'lodash';
import locationService from '../../services/locationService';
import companyService from '../../services/companyService';
import roleService from '../../services/roleService';
import departmentService from '../../services/departmentService';
import permissionService from '../../services/permissionService';
import itemTypeService from '../../services/itemTypeService';
import eventService from '../../services/eventService';
import itemService from '../../services/itemService';
import itemDeliveryService from '../../services/itemDeliveryService';
import elementItemService from '../../services/elementItemService';
import { createUserOtp, usesFixedOtp } from '../../utils/userOtp';
import { toast } from 'react-toastify';

const UserForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const roles = JSON.parse(localStorage?.getItem('roles'));
  const [initialValues, setInitialValues] = useState({
    username: '',
    phone: '',
    location_id: '',
    vendor_id: '',
    company: '',
    // shift_duration: '',
    roles: [],
    permissions: [],
    products: [],
    stations: [],
    email: '',
    password: 'Password@321',
    station_type: '',
    location: '',
    zones: '',
  });
  // const [locations, setLocations] = useState([]);
  const [permissionList, setPermissionList] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [stationsLoaded, setStationsLoaded] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [products, setProducts] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [structureLocations, setStructureLocations] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);

  const fetchStations = async (type) => {
    setStationsLoaded(false);
    try {
      const res = await itemDeliveryService?.getItemDeliveries(
        localStorage?.getItem('event_id'),
      );
      if (res?.status === 200) {
        setDepartments(
          uniqBy(
            filter(
              res?.data,
              (data) =>
                data?.event_id ===
                  parseInt(localStorage?.getItem('event_id')) &&
                data?.station_type === type,
            ),
            'station',
          ),
        );
      } else {
        setDepartments([]);
      }
    } catch (error) {
      setDepartments([]);
    } finally {
      setStationsLoaded(true);
    }
  };

  const fetchStructureLocations = async () => {
    const eventId = localStorage.getItem('event_id');
    if (!eventId) return;
    try {
      const response = await elementItemService.getElementLocations(eventId);
      setStructureLocations(response?.data?.locations || []);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Could not load locations',
      );
    }
  };

  const zoneKey = (zone) => `${zone.section_code}||${zone.zone}`;

  const fetchProduct = async (type) => {
    try {
      const response = await itemService?.getItemsByEventId();
      setProducts(
        filter(response?.data, (data) => data?.station_type === type),
      );
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  useEffect(() => {
    // const fetchLocations = async () => {
    //   const response = await locationService.getLocations();
    //   setLocations(response?.data);
    // };

    // const fetchDepartment = async () => {
    //   const response = await departmentService.getDepartments();
    //   setDepartments(response.data);
    // };
    // fetchDepartment();

    // const fetchCompanies = async () => {
    //   const response = await companyService?.getCompanies();
    //   setCompanies(response?.data);
    // };

    console.log('roles', roles);

    const fetchRoles = async () => {
      const response = await roleService?.getRoles();
      console.log('response?.data', response?.data);

      setRoleList(
        filter(response?.data, (data) =>
          (data?.name === 'ADMIN' || data?.name === 'COMMAND CENTER') &&
          isEqual(roles, ['ADMIN', 'SUPER ADMIN'])
            ? data
            : data?.name !== 'COMMAND CENTER' && !includes(roles, data?.name),
        ),
      );
    };

    const fetchPermssion = async () => {
      const response = await permissionService?.getPermissions();
      setPermissionList(response?.data);
    };

    // const fetchDepartment = async () => {
    //   const response = await departmentService?.getDepartments();
    //   setDepartments(response?.data);
    // };

    const fetchUser = async () => {
      if (id) {
        const response = await userService.getUser(id);

        const tryParseJson = (value) => {
          if (typeof value === 'string' && value.trim()) {
            try {
              return JSON.parse(value); // Try parsing the string as JSON
            } catch (e) {
              return [value]; // Return the original string if parsing fails
            }
          }
          return value; // Return the value as is if it's not a string
        };

        const savedPermissions =
          tryParseJson(response?.data?.permissions) || [];

        setInitialValues({
          first_name: split(response?.data?.username, ' ')[0],
          last_name: split(response?.data?.username, ' ')[1],
          phone: response?.data?.phone,
          department_id: response?.data?.department_id,
          stations: tryParseJson(response?.data?.stations) || [], // Try parsing or return empty array
          vendor_id: response?.data?.vendor_id,
          company: response?.data?.company || '',
          roles: tryParseJson(response?.data?.roles) || [], // Try parsing or return empty array
          permissions: savedPermissions,
          products: tryParseJson(response?.data?.products) || [],
          email: response?.data?.email,
          station_type: response?.data?.station_type,
          location: '',
          zones: response?.data?.zones || '',
        });        

        if (includes(tryParseJson(response?.data?.roles) || [], 'ZONE HEAD')) {
          fetchStructureLocations();
        }

        if (
          id &&
          (response?.data?.station_type === 'ROUTE' ||
            response?.data?.station_type === 'JUNCTION')
        ) {
          fetchStations(response?.data?.station_type);
          const savedStations = tryParseJson(response?.data?.stations) || [];
          if (!isEmpty(flatMap(savedStations))) {
            fetchProduct(response?.data?.station_type);
          }
        }
      }
    };

    // fetchLocations();
    fetchPermssion();
    // fetchDepartment();
    // fetchCompanies();
    fetchUser();
    fetchRoles();
    // fetchProductTypes();
  }, [id]);

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    phone: Yup.string()
      .required('Phone number is required') // Required field
      .matches(
        /^[0-9]{10}$/,
        'Phone number must be 10 digits long', // Validate that the phone number is 10 digits
      )
      .required('Phone number is required'),
    // department_id: Yup.string().required('Station is required'),
    // vendor_id: Yup.string().required('Vendor is required'),
    // shift_duration: Yup.string().required('Shift duration is required'),
    email: Yup.string().required('Email is required'),
    zones: Yup.string()
      .transform((value, originalValue) =>
        Array.isArray(originalValue) ? '' : value ?? '',
      )
      .test('zones-required', 'Zone is required', function (value) {
        if (!includes(this.parent.roles, 'ZONE HEAD')) return true;
        return Boolean(String(value || '').trim());
      }),
  });

  const handleSubmit = async (val, { setSubmitting }) => {
    const usesOtp = usesFixedOtp(val?.roles);
    let otpCode = '';
    if (usesOtp && /^[0-9]{10}$/.test(String(val?.phone || ''))) {
      const generated = await createUserOtp(val.phone);
      otpCode = generated.otp;
    }

    const values = {
      ...val,
      username:
        val?.first_name && val?.last_name
          ? join([val?.first_name, val?.last_name], ' ')
          : val?.first_name,
      photo: '',
      active: true,
      roles: JSON.stringify(val?.roles),
      permissions: JSON.stringify(val?.permissions),
      products: JSON.stringify(flatMap(val?.products)),
      stations: JSON.stringify(flatMap(val?.stations)),
      location: '',
      zones: includes(val?.roles, 'ZONE HEAD') ? String(val?.zones || '') : '',
      // item_types_id: JSON.stringify(
      //   map(
      //     filter(products, (item) =>
      //       includes(val?.product_types, item.type)
      //     ),
      //     'id'
      //   )
      // ),
    };

    try {
      if (id) {
        await userService.updateUser(
          id,
          omit(values, [
            'first_name',
            'last_name',
            'location_id',
            'vendor_id',
            'password',
            'otp',
            'otp_hash',
          ]),
        );
      } else {
        await userService.createUser(
          omit(values, [
            'first_name',
            'last_name',
            'location_id',
            'vendor_id',
            'otp',
            'otp_hash',
          ]),
        );
        if (otpCode) {
          toast.success(`User created.`);
        }
      }
      navigate('/users');
    } catch (error) {
      toast?.error(error?.response?.data?.message);
      console.error(error); // Handle error appropriately
    } finally {
      setSubmitting(false);
    }
  };

  const menuBox = {
    PaperProps: {
      style: {
        maxHeight: 200,
        width: 160,
      },
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    getContentAnchorEl: null,
  };

  return (
    <LayoutContainer>
      <AdminHeader title={id ? 'EDIT USER' : 'ADD USER'} backTo='/users' />
      <Box
        className='page-content-wrapper scrollable'
        p={3}
        mb={3}
        sx={{ display: 'flex', backgroundColor: '#efefef' }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={!!id}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit} style={{ width: '50%' }}>
              <Card>
                {console.log('errors', errors)}
                <CardContent>
                  <Grid container spacing={3} sx={{ p: 1 }}>
                    {[
                      { name: 'first_name', label: 'FIRST NAME' },
                      { name: 'last_name', label: 'LAST NAME' },
                      { name: 'phone', label: 'PHONE' },
                      { name: 'email', label: 'EMAIL' },
                    ].map(({ name, label, type = 'text' }, index) => (
                      <Grid
                        item
                        xs={12}
                        key={name}
                        sx={{ pt: index !== 0 && '10px !important' }}
                      >
                        <Typography variant='body2' sx={{ fontWeight: 600 }}>
                          {label}{' '}
                          {name !== 'last_name' && (
                            <span style={{ color: 'red' }}>*</span>
                          )}
                        </Typography>
                        <TextField
                          name={name}
                          type={type}
                          fullWidth
                          value={values[name]}
                          onChange={(e) => {
                            const capitalizedValue =
                              name === 'email'
                                ? e.target.value
                                : toUpper(e.target.value);
                            handleChange({
                              target: { name: name, value: capitalizedValue },
                            });
                          }}
                          onBlur={handleBlur}
                          sx={{
                            backgroundColor: '#f5f5f5',
                            borderRadius: 1,
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                borderColor:
                                  touched?.[name] && errors?.[name]
                                    ? '#d32f2f'
                                    : '#ccc',
                              },
                            },
                          }}
                          inputProps={{
                            maxLength: name === 'phone' && 10,
                            pattern: name === 'phone' && '[0-9]{10}',
                          }}
                        />
                        {errors?.[name] && (
                          <FormHelperText error>
                            {errors?.[name]}
                          </FormHelperText>
                        )}
                      </Grid>
                    ))}
                    {/* <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Shift Duration (hour)
                      </Typography>
                      <TextField
                        select
                        name='shift_duration'
                        fullWidth
                        value={values.shift_duration || ''}
                        onChange={(e) => {
                          setFieldValue('shift_duration', e?.target?.value);
                        }}
                        onBlur={handleBlur}
                        SelectProps={{
                          MenuProps: {
                            ...menuBox,
                          },
                        }}
                      >
                        {range(1, 25)?.map((number) => (
                          <MenuItem key={number} value={number}>
                            {number}
                          </MenuItem>
                        ))}
                      </TextField>
                      {touched?.shift_duration && errors?.shift_duration && (
                        <FormHelperText error>
                          {errors?.shift_duration}
                        </FormHelperText>
                      )}
                    </Grid> */}
                    {/* <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Station
                      </Typography>
                      <TextField
                        select
                        name='department_id'
                        fullWidth
                        value={values.department_id || ''}
                        onChange={(e) => {
                          setFieldValue('department_id', e?.target?.value);
                          setFieldValue(
                            'stations',
                            find(departments, { id: e?.target?.value })?.name
                          );
                        }}
                        onBlur={handleBlur}
                        SelectProps={{
                          MenuProps: {
                            ...menuBox,
                          },
                        }}
                        error={
                          touched.department_id && Boolean(errors.department_id)
                        }
                        helperText={
                          touched.department_id && errors.department_id
                        }
                      >
                        {departments?.map((department) => (
                          <MenuItem key={department.id} value={department.id}>
                            {toUpper(department.name)}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid> */}

                    <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        ROLES
                      </Typography>
                      <TextField
                        select
                        name='roles'
                        fullWidth
                        value={values?.roles || []}
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          const nextRoles =
                            typeof value === 'string'
                              ? value.split(',')
                              : value;
                          setFieldValue('roles', nextRoles);
                          handleChange(e);
                          if (includes(nextRoles, 'ZONE HEAD')) {
                            fetchStructureLocations();
                          }
                          setFieldValue('permissions', []);
                          setFieldValue('station_type', '');
                          setFieldValue('stations', []);
                          setFieldValue('products', []);
                          setFieldValue('location', '');
                          setFieldValue('zones', '');
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.roles && errors.roles
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                        SelectProps={{
                          multiple: true,
                          renderValue: (selected) => selected.join(', '), // Display selected roles as a comma-separated string
                          MenuProps: {
                            ...menuBox,
                          },
                        }}
                      >
                        {roleList?.map((role) => (
                          <MenuItem key={role.name} value={role.name}>
                            <Checkbox
                              checked={values.roles?.includes(role.name)}
                              sx={{ padding: 0, marginRight: '8px' }}
                            />
                            {toUpper(role.name)}
                          </MenuItem>
                        ))}
                      </TextField>
                      {touched.roles && errors.roles && (
                        <FormHelperText error>{errors.roles}</FormHelperText>
                      )}
                    </Grid>

                    {(includes(values?.roles, 'USER') ||
                      includes(values?.roles, 'ZONE HEAD') ||
                      includes(values?.roles, 'STATION SUPERVISOR')) && (
                      <>
                        {(includes(values?.roles, 'USER') ||
                          includes(values?.roles, 'STATION SUPERVISOR')) && (
                          <Grid item xs={12} sx={{ pt: '10px !important' }}>
                            <Typography
                              variant='body2'
                              sx={{ fontWeight: 600 }}
                            >
                              PERMISSIONS
                            </Typography>
                            <TextField
                              select
                              name='permissions'
                              fullWidth
                              value={values?.permissions || []}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                const nextPermissions =
                                  typeof value === 'string'
                                    ? value.split(',')
                                    : value;
                                setFieldValue(
                                  'permissions', // Note the plural here matches 'name' value
                                  nextPermissions,
                                );
                                handleChange(e);
                                const showStationType = [
                                  'DELIVERED ITEM',
                                  'PICKED-UP ITEM',
                                  'SUPERVISOR FORM',
                                ].some((item) =>
                                  includes(nextPermissions, item),
                                );
                                if (!showStationType) {
                                  setFieldValue('station_type', '');
                                  setFieldValue('stations', []);
                                  setFieldValue('products', []);
                                }
                              }}
                              onBlur={handleBlur}
                              sx={{
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor:
                                      touched.permissions && errors.permissions
                                        ? '#d32f2f'
                                        : '#ccc',
                                  },
                                },
                              }}
                              SelectProps={{
                                MenuProps: {
                                  ...menuBox,
                                },
                                multiple: true,
                                renderValue: (selected) => selected.join(', '), // Display selected items as a comma-separated string
                              }}
                            >
                              {permissionList?.map((permission) => (
                                <MenuItem
                                  key={permission.name}
                                  value={permission.name}
                                >
                                  <Checkbox
                                    checked={values.permissions?.includes(
                                      permission.name,
                                    )}
                                    sx={{ padding: 0, marginRight: '8px' }}
                                  />
                                  {toUpper(permission.name)}
                                </MenuItem>
                              ))}
                            </TextField>
                            {touched.permissions && errors.permissions && (
                              <FormHelperText error>
                                {errors.permissions}
                              </FormHelperText>
                            )}
                          </Grid>
                        )}

                        {/* {includes(values?.roles, 'ZONE HEAD') && (
                            <Grid item xs={12} sx={{ pt: '10px !important' }}>
                              <Typography variant='body2' sx={{ fontWeight: 600 }}>
                                LOCATION <span style={{ color: 'red' }}>*</span>
                              </Typography>
                              <TextField
                                select
                                name='location'
                                fullWidth
                                value={values?.location || ''}
                                onChange={(event) => {
                                  const nextLocation = event.target.value;
                                  setFieldValue('location', nextLocation);
                                  setFieldValue('zones', []);
                                }}
                                onBlur={handleBlur}
                                sx={{
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: 1,
                                  '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                      borderColor:
                                        touched.location && errors.location
                                          ? '#d32f2f'
                                          : '#ccc',
                                    },
                                  },
                                }}
                                SelectProps={{
                                  MenuProps: {
                                    ...menuBox,
                                  },
                                  displayEmpty: true,
                                }}
                              >
                                <MenuItem value='' disabled>
                                  Select location
                                </MenuItem>
                                {structureLocations.map((item) => (
                                  <MenuItem key={item.location} value={item.location}>
                                    {toUpper(item.location)}
                                  </MenuItem>
                                ))}
                              </TextField>
                              {touched.location && errors.location && (
                                <FormHelperText error>{errors.location}</FormHelperText>
                              )}
                            </Grid>
                          )} */}

                        {/* {includes(values?.roles, 'ZONE HEAD') && (
                            <Grid item xs={12} sx={{ pt: '10px !important' }}>
                              <Typography
                                variant='body2'
                                sx={{ fontWeight: 600 }}
                              >
                                ZONES <span style={{ color: 'red' }}>*</span>
                              </Typography>
                              <TextField
                                select
                                name='zones'
                                fullWidth
                                value={values?.zones || ''}
                                onChange={(event) => {
                                  const nextLocation = event.target.value;
                                  setFieldValue('zones', nextLocation);
                                }}
                                onBlur={handleBlur}
                                sx={{
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: 1,
                                  '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                      borderColor:
                                        touched.zones && errors.zones
                                          ? '#d32f2f'
                                          : '#ccc',
                                    },
                                  },
                                }}
                                SelectProps={{
                                  MenuProps: {
                                    ...menuBox,
                                  },
                                  displayEmpty: true,
                                }}
                              >
                                <MenuItem value='' disabled>
                                  Select zone
                                </MenuItem>
                                {structureLocations.map((item) => (
                                  <MenuItem
                                    key={item.location}
                                    value={item.location}
                                  >
                                    {toUpper(item.location)}
                                  </MenuItem>
                                ))}
                              </TextField>
                              {touched.zones && errors.zones && (
                                <FormHelperText error>
                                  {errors.zones}
                                </FormHelperText>
                              )}
                            </Grid>
                          )} */}

                        {includes(values?.roles, 'ZONE HEAD') && (
                          <Grid item xs={12} sx={{ pt: '10px !important' }}>
                            <Typography
                              variant='body2'
                              sx={{ fontWeight: 600 }}
                            >
                              ZONE <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <TextField
                              select
                              name='zones'
                              fullWidth
                              value={values?.zones || ''}
                              onChange={(event) => {
                                const nextZone = event.target.value;
                                setFieldValue('zones', nextZone);
                              }}
                              onBlur={handleBlur}
                              sx={{
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor:
                                      touched.zones && errors.zones
                                        ? '#d32f2f'
                                        : '#ccc',
                                  },
                                },
                              }}
                              SelectProps={{
                                MenuProps: {
                                  ...menuBox,
                                },
                                displayEmpty: true,
                              }}
                            >
                              <MenuItem value='' disabled>
                                Select zone
                              </MenuItem>
                              {structureLocations.map((item) => (
                                <MenuItem
                                  key={item.location}
                                  value={item.location}
                                >
                                  {toUpper(item.location)}
                                </MenuItem>
                              ))}
                            </TextField>
                            {touched.zones && errors.zones && (
                              <FormHelperText error>
                                {errors.zones}
                              </FormHelperText>
                            )}
                          </Grid>
                        )}

                        {[
                          'DELIVERED ITEM',
                          'PICKED-UP ITEM',
                          'SUPERVISOR FORM',
                        ].some((item) =>
                          includes(values?.permissions, item),
                        ) && (
                          <Grid item xs={12} sx={{ pt: '10px !important' }}>
                            <Typography
                              variant='body2'
                              sx={{ fontWeight: 600 }}
                            >
                              TYPE <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <RadioGroup
                              name='station_type'
                              // fullWidth
                              value={values.station_type || ''}
                              onChange={(e) => {
                                const capitalizedValue = toUpper(
                                  e.target.value,
                                ); // Capitalize first letter
                                handleChange({
                                  target: {
                                    name: 'station_type',
                                    value: capitalizedValue,
                                  },
                                });
                                setFieldValue('stations', []);
                                setFieldValue('products', []);
                                setProducts([]);
                                fetchStations(capitalizedValue);
                              }}
                              onBlur={handleBlur}
                              row
                            >
                              <FormControlLabel
                                value='JUNCTION'
                                control={<Radio />}
                                label='JUNCTION'
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '0.675rem',
                                    fontWeight: 500,
                                    color: '#333',
                                  },
                                }}
                              />
                              <FormControlLabel
                                value='ROUTE'
                                control={<Radio />}
                                label='ROUTE'
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '0.675rem',
                                    fontWeight: 500,
                                    color: '#333',
                                  },
                                }}
                              />
                            </RadioGroup>
                            {touched.station_type && errors.station_type && (
                              <FormHelperText error>
                                {errors.station_type}
                              </FormHelperText>
                            )}
                          </Grid>
                        )}
                      </>
                    )}

                    {(values.station_type === 'JUNCTION' ||
                      values.station_type === 'ROUTE') && (
                      <>
                        <Grid item xs={12} sx={{ pt: '10px !important' }}>
                          <Typography variant='body2' sx={{ fontWeight: 600 }}>
                            STATION
                          </Typography>
                          {stationsLoaded && isEmpty(departments) ? (
                            <Typography
                              variant='body2'
                              sx={{ color: '#d32f2f', mt: 0.5 }}
                            >
                              Stations are not available
                            </Typography>
                          ) : (
                            <TextField
                              select
                              name='stations'
                              fullWidth
                              value={values?.stations || []}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                const nextStations =
                                  typeof value === 'string'
                                    ? value.split(',')
                                    : value;
                                setFieldValue('stations', nextStations);
                                handleChange(e);
                                if (!isEmpty(flatMap(nextStations))) {
                                  fetchProduct(values.station_type);
                                } else {
                                  setProducts([]);
                                  setFieldValue('products', []);
                                }
                              }}
                              onBlur={handleBlur}
                              sx={{
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor:
                                      touched.stations && errors.stations
                                        ? '#d32f2f'
                                        : '#ccc',
                                  },
                                },
                              }}
                              SelectProps={{
                                multiple: true,
                                renderValue: (selected) => selected.join(', '), // Display selected roles as a comma-separated string
                                MenuProps: {
                                  ...menuBox,
                                },
                              }}
                            >
                              {/* {!isEmpty(departments) && (
                              <MenuItem
                                value={departments?.map((data) => data.station)}
                                // onClick={() => {
                                //   const allStations = departments?.map(
                                //     (data) => data.station
                                //   );
                                //   setFieldValue('stations', allStations);
                                // }}
                              >
                                <Checkbox
                                  // checked={}
                                  
                                  sx={{ padding: 0, marginRight: '8px' }}
                                />
                                SELECT ALL
                              </MenuItem>
                            )} */}
                              {!isEmpty(departments) && (
                                <MenuItem
                                  value={departments.map(
                                    (data) => data.station,
                                  )}
                                >
                                  <Checkbox
                                    checked={
                                      values.stations?.length ===
                                      departments.length
                                    } // If all stations are selected, check it
                                    onChange={(e) => {
                                      const allStations = departments.map(
                                        (data) => data.station,
                                      );
                                      // If checkbox is checked, select all stations. If unchecked, deselect all.
                                      setFieldValue(
                                        'stations',
                                        e.target.checked ? allStations : [], // Select all or deselect all based on checkbox state
                                      );
                                      if (e.target.checked) {
                                        fetchProduct(values.station_type);
                                      } else {
                                        setProducts([]);
                                        setFieldValue('products', []);
                                      }
                                    }}
                                    sx={{ padding: 0, marginRight: '8px' }}
                                  />
                                  {values.stations?.length ===
                                  departments.length
                                    ? 'DESELECT ALL'
                                    : 'SELECT ALL'}
                                </MenuItem>
                              )}
                              {!isEmpty(departments) ? (
                                departments?.map((data) => (
                                  <MenuItem key={data.id} value={data.station}>
                                    <Checkbox
                                      checked={flatMap(
                                        values.stations,
                                      )?.includes(data.station)}
                                      sx={{ padding: 0, marginRight: '8px' }}
                                    />
                                    {toUpper(data.station)}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>
                                  Stations are not available
                                </MenuItem>
                              )}
                            </TextField>
                          )}
                          {touched.stations && errors.stations && (
                            <FormHelperText error>
                              {errors.stations}
                            </FormHelperText>
                          )}
                        </Grid>

                        {!isEmpty(flatMap(values?.stations)) && (
                          <Grid item xs={12} sx={{ pt: '10px !important' }}>
                            <Typography
                              variant='body2'
                              sx={{ fontWeight: 600 }}
                            >
                              Products
                            </Typography>
                            <TextField
                              select
                              name='products'
                              fullWidth
                              value={values?.products || []}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setFieldValue(
                                  'products',
                                  typeof value === 'string'
                                    ? value.split(',')
                                    : value,
                                );
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              sx={{
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor:
                                      touched.products && errors.products
                                        ? '#d32f2f'
                                        : '#ccc',
                                  },
                                },
                              }}
                              SelectProps={{
                                multiple: true,
                                renderValue: (selected) => selected.join(', '), // Display selected roles as a comma-separated string
                                MenuProps: {
                                  ...menuBox,
                                },
                              }}
                            >
                              {!isEmpty(products) && (
                                <MenuItem
                                  value={products?.map(
                                    (data) => data?.item_name,
                                  )} // Set value to select all products
                                >
                                  <Checkbox
                                    checked={
                                      flatMap(values.products)?.length ===
                                      products?.length
                                    } // If all products are selected, check it
                                    onChange={(e) => {
                                      const allProductNames = products?.map(
                                        (data) => data.item_name,
                                      ); // All product names
                                      setFieldValue(
                                        'products',
                                        e.target.checked ? allProductNames : [], // Select all or deselect all based on checkbox state
                                      );
                                    }}
                                    sx={{ padding: 0, marginRight: '8px' }}
                                  />
                                  {flatMap(values.products)?.length ===
                                  products?.length
                                    ? 'DESELECT ALL'
                                    : 'SELECT ALL'}
                                </MenuItem>
                              )}
                              {!isEmpty(products) ? (
                                products?.map((type) => (
                                  <MenuItem
                                    key={type.item_name}
                                    value={type.item_name}
                                  >
                                    <Checkbox
                                      checked={flatMap(
                                        values.products,
                                      )?.includes(type.item_name)} // If the product is selected, check it
                                      sx={{ padding: 0, marginRight: '8px' }}
                                    />
                                    {toUpper(type?.item_name)}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem>No data found</MenuItem>
                              )}
                            </TextField>
                            {touched.products && errors.products && (
                              <FormHelperText error>
                                {errors.products}
                              </FormHelperText>
                            )}
                          </Grid>
                        )}
                      </>

                      // <>
                      //   <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      //     <Typography variant='body2' sx={{ fontWeight: 600 }}>
                      //       STATION
                      //     </Typography>
                      //     <TextField
                      //       select
                      //       name='stations'
                      //       fullWidth
                      //       value={values?.stations || []}
                      //       onChange={(e) => {
                      //         const {
                      //           target: { value },
                      //         } = e;
                      //         setFieldValue(
                      //           'stations',
                      //           typeof value === 'string'
                      //             ? value.split(',')
                      //             : value
                      //         );
                      //         handleChange(e);
                      //       }}
                      //       onBlur={handleBlur}
                      //       sx={{
                      //         backgroundColor: '#f5f5f5',
                      //         borderRadius: 1,
                      //         '& .MuiOutlinedInput-root': {
                      //           '& fieldset': {
                      //             borderColor:
                      //               touched.stations && errors.stations
                      //                 ? '#d32f2f'
                      //                 : '#ccc',
                      //           },
                      //         },
                      //       }}
                      //       SelectProps={{
                      //         multiple: true,
                      //         renderValue: (selected) => selected.join(', '), // Display selected roles as a comma-separated string
                      //         MenuProps: {
                      //           ...menuBox,
                      //         },
                      //       }}
                      //     >
                      //       {!isEmpty(departments) ? (
                      //         departments?.map((data) => (
                      //           <MenuItem key={data.id} value={data.station}>
                      //             <Checkbox
                      //               checked={values.stations?.includes(
                      //                 data.station
                      //               )}
                      //               sx={{ padding: 0, marginRight: '8px' }}
                      //             />
                      //             {toUpper(data.station)}
                      //           </MenuItem>
                      //         ))
                      //       ) : (
                      //         <MenuItem>No data found</MenuItem>
                      //       )}
                      //     </TextField>
                      //     {touched.stations && errors.stations && (
                      //       <FormHelperText error>
                      //         {errors.stations}
                      //       </FormHelperText>
                      //     )}
                      //   </Grid>
                      //   <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      //     <Typography variant='body2' sx={{ fontWeight: 600 }}>
                      //       Products
                      //     </Typography>
                      //     <TextField
                      //       select
                      //       name='products'
                      //       fullWidth
                      //       value={values?.products || []}
                      //       onChange={(e) => {
                      //         const {
                      //           target: { value },
                      //         } = e;
                      //         setFieldValue(
                      //           'products',
                      //           typeof value === 'string'
                      //             ? value.split(',')
                      //             : value
                      //         );
                      //         handleChange(e);
                      //       }}
                      //       onBlur={handleBlur}
                      //       sx={{
                      //         backgroundColor: '#f5f5f5',
                      //         borderRadius: 1,
                      //         '& .MuiOutlinedInput-root': {
                      //           '& fieldset': {
                      //             borderColor:
                      //               touched.products && errors.products
                      //                 ? '#d32f2f'
                      //                 : '#ccc',
                      //           },
                      //         },
                      //       }}
                      //       SelectProps={{
                      //         multiple: true,
                      //         renderValue: (selected) => selected.join(', '), // Display selected roles as a comma-separated string
                      //         MenuProps: {
                      //           ...menuBox,
                      //         },
                      //       }}
                      //     >
                      //       {!isEmpty(products) ? (
                      //         products?.map((type) => (
                      //           <MenuItem
                      //             key={type.item_name}
                      //             value={type.item_name}
                      //           >
                      //             <Checkbox
                      //               checked={values.products?.includes(
                      //                 type.item_name
                      //               )}
                      //               sx={{ padding: 0, marginRight: '8px' }}
                      //             />
                      //             {toUpper(type?.item_name)}
                      //           </MenuItem>
                      //         ))
                      //       ) : (
                      //         <MenuItem>No data found</MenuItem>
                      //       )}
                      //     </TextField>
                      //     {touched.products && errors.products && (
                      //       <FormHelperText error>
                      //         {errors.products}
                      //       </FormHelperText>
                      //     )}
                      //   </Grid>
                      // </>
                    )}

                    {/* <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Product Types
                      </Typography>
                      <TextField
                        select
                        name='product_types'
                        fullWidth
                        value={values?.product_types || []}
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setFieldValue(
                            'product_types',
                            typeof value === 'string' ? value.split(',') : value
                          );
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.product_types && errors.product_types
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                        SelectProps={{
                          multiple: true,
                          renderValue: (selected) => selected.join(', '), // Display selected roles as a comma-separated string
                          MenuProps: {
                            ...menuBox,
                          },
                        }}
                      >
                        {products?.map((type) => (
                          <MenuItem key={type.type} value={type.type}>
                            <Checkbox
                              checked={values.product_types?.includes(
                                type.type
                              )}
                              sx={{ padding: 0, marginRight: '8px' }}
                            />
                            {toUpper(type.type)}
                          </MenuItem>
                        ))}
                      </TextField>
                      {touched.product_types && errors.product_types && (
                        <FormHelperText error>
                          {errors.product_types}
                        </FormHelperText>
                      )}
                    </Grid> */}
                    {/* <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Vendor <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        select
                        name='vendor_id'
                        fullWidth
                        value={values.vendor_id}
                        onChange={(e) => {
                          setFieldValue('vendor_id', e?.target?.value);
                          setFieldValue(
                            'company',
                            find(companies, { id: e?.target?.value })?.name
                          );
                        }}
                        SelectProps={{
                          MenuProps: {
                            ...menuBox,
                          },
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.vendor_id && errors.vendor_id
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                      >
                        {companies?.map((company) => (
                          <MenuItem key={company.id} value={company.id}>
                            {toUpper(company.name)}
                          </MenuItem>
                        ))}
                      </TextField>
                      {touched.vendor_id && errors.vendor_id && (
                        <FormHelperText error>
                          {errors.vendor_id}
                        </FormHelperText>
                      )}
                    </Grid> */}

                    {/* <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Roles
                      </Typography>
                      <TextField
                        select
                        name='roles'
                        fullWidth
                        value={values?.roles || []}
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setFieldValue(
                            'roles',
                            typeof value === 'string' ? value.split(',') : value
                          );
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.roles && errors.roles
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                        SelectProps={{
                          multiple: true,
                        }}
                      >
                        {roleList?.map((role) => (
                          <MenuItem key={role.name} value={role.name}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      {touched.roles && errors.roles && (
                        <FormHelperText error>{errors.roles}</FormHelperText>
                      )}
                    </Grid> */}
                    {/* <Grid item xs={12} sx={{ pt: '10px !important' }}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Permissions
                      </Typography>
                      <TextField
                        select
                        name='permissions'
                        fullWidth
                        value={values?.permissions || []}
                        onChange={(e) => {
                          const {
                            target: { value },
                          } = e;
                          setFieldValue(
                            'permission',
                            typeof value === 'string' ? value.split(',') : value
                          );
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.permissions && errors.permissions
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                        SelectProps={{
                          multiple: true,
                        }}
                      >
                        {permissionList?.map((permission) => (
                          <MenuItem
                            key={permission.name}
                            value={permission.name}
                          >
                            {permission.name}
                          </MenuItem>
                        ))}
                      </TextField>
                      {touched.permissions && errors.permissions && (
                        <FormHelperText error>
                          {errors.permissions}
                        </FormHelperText>
                      )}
                    </Grid> */}
                  </Grid>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      type='submit'
                      variant='contained'
                      sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                    >
                      {id ? 'UPDATE' : 'CREATE'}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Form>
          )}
        </Formik>
      </Box>
    </LayoutContainer>
  );
};

export default UserForm;
